import React from 'react';
import { Checkbox } from '@mui/material';
import { beautifyNumber } from '../../../Utils/FormatNumber';
import { MANUAL_COLUMNS, calculateNetVat, isRowDirty } from './yearlyVatReportUtils';

/**
 * Editable grid of reported VAT for every period of the year, so a whole year can be
 * reported manually in one pass instead of one period at a time.
 */
const YearlyVatManualEntry = ({ t, rows, onChangeValue, onToggleRow, onToggleAll }) => {
    const allSelected = rows.length > 0 && rows.every((row) => row.selected);
    const someSelected = rows.some((row) => row.selected);

    return (
        <div className="yvr__table-wrapper">
            <table className="yvr__table">
                <thead>
                    <tr>
                        <th style={{ width: 48 }}>
                            <Checkbox
                                size="small"
                                checked={allSelected}
                                indeterminate={someSelected && !allSelected}
                                onChange={(event) => onToggleAll(event.target.checked)}
                            />
                        </th>
                        <th>{t('Period')}</th>
                        {MANUAL_COLUMNS.map((column) => (
                            <th key={column.key}>{t(column.labelKey)}</th>
                        ))}
                        <th>{t('VATToPay')}</th>
                        <th>{t('Status')}</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.periodKey} className={isRowDirty(row) ? 'yvr__manual-row--dirty' : ''}>
                            <td>
                                <Checkbox
                                    size="small"
                                    checked={row.selected}
                                    onChange={(event) => onToggleRow(row.periodKey, event.target.checked)}
                                />
                            </td>
                            <td className="yvr__row-label">{row.periodKey}</td>
                            {MANUAL_COLUMNS.map((column) => (
                                <td key={column.key}>
                                    <input
                                        type="number"
                                        className={`yvr__manual-input ${row.filledFromDocument ? 'yvr__manual-input--filled' : ''}`}
                                        value={row.values[column.key] ?? 0}
                                        onChange={(event) => onChangeValue(row.periodKey, column.key, event.target.value)}
                                    />
                                </td>
                            ))}
                            <td className="yvr__manual-net">{beautifyNumber(calculateNetVat(row.values), 0, true)}</td>
                            <td>
                                {row.isReported ? t('Reported') : t('Unreported')}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default YearlyVatManualEntry;
